import $http from "../axios";

const state = {
  purchasesInvoices: [],
  purchasesInvoicesQty: 0
};

const getters = {
  purchasesInvoices(state) {
    return state.purchasesInvoices;
  },

  purchasesInvoicesQty(state) {
    return state.purchasesInvoicesQty;
  }
};

const actions = {
  getPurchasesInvoices({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          // eslint-disable-next-line prettier/prettier
          `purchase-invoice/purchases-invoices`,
          { params: { ...data } }
        )
        .then(res => {
          if (res.data.result === "ok") {
            commit("SET_PURCHASES_INVOICES", res.data.payload);
          }
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  downloadInvoice({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          // eslint-disable-next-line prettier/prettier
          `purchase-invoice/download-invoice`,
          { params: { ...data } }
        )
        .then(res => {
          var blob = new Blob([res.data]);
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //create the download url
          downloadElement.href = href;
          downloadElement.download = `${data.access_key}.xml`; //the name of the downloaded file
          document.body.appendChild(downloadElement);
          downloadElement.click(); //click to file
          document.body.removeChild(downloadElement); //remove the element
          window.URL.revokeObjectURL(href); //release the object  of the blob
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  },

  syncInvoices({ commit }) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          // eslint-disable-next-line prettier/prettier
          `purchase-invoice/sync-invoices`
        )
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }

  // getTransactions({ commit }, data) {
  //   return new Promise((resolve, reject) => {
  //     $http
  //       .get(
  //         // eslint-disable-next-line prettier/prettier
  //         `transactions?beginDate=${
  //           data.dates[0]
  //         }&endDate=${
  //           data.dates[1]
  //         }&currency=${
  //           data.currency
  //         }&merchantStore=${
  //           data.merchantStore
  //         }&id=${
  //           data.id
  //         }&personalId=${
  //           data.personalId
  //         }&cellphone=${
  //           data.cellphone
  //         }&email=${
  //           data.email
  //         }&transactionId=${
  //           data.transactionId
  //         }&skip=${
  //           data.skip
  //         }&limit=${
  //           data.limit
  //         }`
  //       )
  //       .then(res => {
  //         if (res.data.result === "ok") {
  //           commit("SET_TRANSACTIONS", res.data.payload);
  //         }
  //         resolve(res);
  //       })
  //       .catch(e => {
  //         reject(e);
  //       });
  //   });
  // },

  // getTransaction(_, transactionId) {
  //   return new Promise((resolve, reject) => {
  //     $http
  //       .get(`transaction?transactionId=${transactionId}`)
  //       .then(res => {
  //         resolve(res);
  //       })
  //       .catch(e => {
  //         reject(e);
  //       });
  //   });
  // },
};

const mutations = {
  SET_PURCHASES_INVOICES(state, payload) {
    state.purchasesInvoicesQty = payload.purchasesInvoicesQty;
    state.purchasesInvoices = payload.purchasesInvoices;
  }

  // SET_TRANSACTIONS(state, payload) {
  //   state.transactions = payload.transactions;
  // },
};

export default {
  state,
  getters,
  actions,
  mutations
};
